// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-winter-data__diode{display:inline-block;width:15px;height:15px;border-radius:15px;overflow:hidden;background-color:#ff0018;margin-right:10px}.czt-winter-data__diode--on{background-color:#72bd43}", ""]);
// Exports
module.exports = exports;
